import store from '../../../vuex/store'
import { firebase } from '@firebase/app'
import '@firebase/auth'
import { captureException } from '@/utils/reporting/reportingService.js'

const updateAuthUserProfile=async(updates)=>{
  try{
    await firebaseUser.updateProfile(updates);
    return {success:true}
  }catch(ex){
    captureException('authService.updateAuthUserProfile() > err: ', ex)
    return {success:false, message: ex}
  }
}

// NB! This also sends out email verification
const createAuthUserCredential = async ({email, password}) =>{
  return await firebase.auth().createUserWithEmailAndPassword(email, password)
}

const sendAuthUserVerificationEmail=async(authUser)=>{
  try{
    authUser.sendEmailVerification();
  }catch(ex){
    captureException('authService.createAuthUserCredential() > err: ', ex)
  }
}

const logOutAuthUser=async ()=>{
  try{
    const response = await firebase.auth().signOut()
    return {success:true, response: response}
  }catch(ex){
    return {success:false, message: ex}
  }
}

// this is not solved with async as the invoking method cannot be async.
const loginAuthUserWithEmailAndPassword=({email, password})=>{
  return firebase.auth().signInWithEmailAndPassword(email, password)
}

const getCurrentFirebaseUser=()=>{
  return firebase.auth().currentUser;
}

const getCurrentUserUid = () => {
  try {
    var uid = store.getters.user.uid
    return uid
  } catch (ex) {
    return false
  }
}

const getCurrentUserToken=()=>{
  try{
    return new Promise((resolve, reject) => {
      if (getIDToken()) {
        resolve(getIDToken());
        return;
      }
      getCurrentFirebaseUser().getIdToken(true)
        .then(token => {
          saveIDToken(token);
          resolve(token);
        }).catch(err => {
          reject(err)
        });
    })
  }catch(error){
    console.log('getCurrentUserToken > error:', error);
    return Promise.reject(error)
  }
}

// Returns logged in or ananymous token
const getAnyFirebaseToken = () => {

  return new Promise((resolve, reject) => {
    if (getIDToken()) {
      resolve(getIDToken());
      return;
    }
    getAnyCurrentUser()
      .then(user => {
        firebase.auth().currentUser.getIdToken(true)
          .then(token => {
            // saveIDToken(token);  //NB! Do not save this locally as it will be used after signup although new user has been created.
            resolve(token);
          }).catch(err => {
            reject(err)
          });

      })
      .catch(err => {
        reject(err)
      })
  })
}

const getAnyCurrentUser = () => {
  return new Promise((resolve, reject) => {
    let currentUser = firebase.auth().currentUser
    if (currentUser) resolve(currentUser)
    else {
      firebase.auth().signInAnonymously()
        .then(user => {
          resolve(user)
        })
        .catch(err => {
          console.log("userRepo | checkForLoginOrGoAnonymous | err:", err)
          reject("Cannot sign in anonymously")
        })
    }
  })
}


// Auto actualize user ID token every 5 minutes (for cases when the page is not reloaded for some time)
(function () {
    const handler = setInterval(async () => {
        try {
            const idToken = await firebase.auth().currentUser.getIdToken(true);
            saveIDToken(idToken);
        }
        catch (error) {
            clearInterval(handler);
        }
    }, 300000);
})();

const getIDToken = () => {
  return sessionStorage.getItem('token') || null;
};

const saveIDToken = (idToken) => {
  sessionStorage.setItem('token', idToken);
};


const clearAllUserTraces = ()=>{
  try{
    if(store.getters.messagingService) store.getters.messagingService.shutdown()
    sessionStorage.clear()
    localStorage.clear();
  
    store.commit("RESET_USER_DATA")
    store.commit("RESET_CHAT_STATE")
    store.commit("RESET_VISITED_PAGES")
    store.commit("RESET_REQUESTS_STATE")
    store.commit("RESET_DEAL_STATE")
    store.commit("RESET_STAY_STATE")
    store.commit("RESET_READ_ONCE_VALUES")
    store.commit("RESET_LISTING_ADD_PROGRESS")
    store.commit("RESET_PROPERTIES_STATE")
    store.commit("CLEAR_ALL_PROPERTIES");
  }catch(err){
    console.log('clearAllUserTraces > err:', err);
  }
}

export { 
  getCurrentUserToken, 
  getCurrentUserUid, 
  getAnyFirebaseToken, 
  getAnyCurrentUser, 
  clearAllUserTraces, 
  getCurrentFirebaseUser, 
  loginAuthUserWithEmailAndPassword,
  createAuthUserCredential,
  updateAuthUserProfile,
  logOutAuthUser,
  sendAuthUserVerificationEmail
}


// WEBPACK FOOTER //
// ./src/platform/auth/services/authService.js